<template>
  <div class="dfu">
    <!-- Header -->
    <div class="dfu-head">
      <div class="dfu-head-left">
        <div class="dfu-ico">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8B5CF6" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
          </svg>
        </div>
        <div>
          <div class="dfu-title">Funil de conversão</div>
          <div class="dfu-sub">Últimos 7 dias · todas VSLs</div>
        </div>
      </div>
    </div>

    <!-- Steps -->
    <div class="dfu-steps">
      <div v-for="(step, i) in stepsComputed" :key="i" class="dfu-step">
        <div class="dfu-step-top">
          <div class="dfu-step-label">
            <div class="dfu-num mono">{{ i + 1 }}</div>
            <span class="dfu-step-name">{{ step.label }}</span>
          </div>
          <div class="dfu-step-right">
            <span class="dfu-step-val mono">{{ step.value }}</span>
            <span class="dfu-step-pct" :style="{ color: step.pctColor }">{{ step.pct }}</span>
          </div>
        </div>
        <div class="dfu-track">
          <div class="dfu-fill" :style="{ width: step.fillW, background: step.gradient }">
            <span class="dfu-shimmer"></span>
          </div>
        </div>
        <div v-if="step.drop" class="dfu-drop">{{ step.drop }}</div>
      </div>
    </div>

    <!-- Revenue footer -->
    <div class="dfu-rev">
      <div class="dfu-rev-left">
        <div class="dfu-rev-ico">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28C76F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
          </svg>
        </div>
        <div>
          <div class="dfu-rev-lbl">Receita estimada</div>
          <div class="dfu-rev-val mono">{{ resolvedRevenueValue }}</div>
        </div>
      </div>
      <div class="dfu-cpa">
        <div class="dfu-cpa-lbl">CPA médio</div>
        <div class="dfu-cpa-val mono">{{ resolvedCpaValue }}</div>
      </div>
    </div>
  </div>
</template>

<script>
const GRADIENTS = [
  'linear-gradient(90deg,#318feb,#3dd5e0)',
  'linear-gradient(90deg,#E86A10,#F5B935)',
  'linear-gradient(90deg,#F5B935,#FFD56B)',
  'linear-gradient(90deg,#8B5CF6,#EC4899)',
  'linear-gradient(90deg,#28C76F,#75e3a6)',
]
const PCT_COLORS = ['#318feb','#E86A10','#F5B935','#8B5CF6','#28C76F']

export default {
  name: 'DashFunnel',
  props: {
    steps: { type: Array, default: null },
    revenueValue: { type: String, default: null },
    cpaValue: { type: String, default: null },
  },
  computed: {
    resolvedRevenueValue() {
      return this.revenueValue || '—'
    },
    resolvedCpaValue() {
      return this.cpaValue || '—'
    },
    stepsComputed() {
      if (this.steps && this.steps.length) {
        const base = this.steps[0]?.rawValue || 1
        return this.steps.map((s, i) => {
          const pctNum = base > 0 ? (s.rawValue / base) * 100 : 0
          return {
            ...s,
            pct: pctNum >= 100 ? '100%' : pctNum.toFixed(1) + '%',
            pctColor: PCT_COLORS[i] || '#28C76F',
            fillW: pctNum >= 100 ? '100%' : pctNum.toFixed(1) + '%',
            gradient: GRADIENTS[i] || GRADIENTS[4],
          }
        })
      }
      return [
        { label: 'Carregou o player',  rawValue: 0, value: '—', pct: '100%', pctColor: '#318feb', fillW: '100%', gradient: GRADIENTS[0], drop: null },
        { label: 'Deu play',           rawValue: 0, value: '—', pct: '—',    pctColor: '#E86A10', fillW: '0%',   gradient: GRADIENTS[1], drop: null },
        { label: 'Engajamento médio',  rawValue: 0, value: '—', pct: '—',    pctColor: '#F5B935', fillW: '0%',   gradient: GRADIENTS[2], drop: null },
        { label: 'Converteu (lead)',   rawValue: 0, value: '—', pct: '—',    pctColor: '#28C76F', fillW: '0%',   gradient: GRADIENTS[4], drop: null },
      ]
    },
  },
}
</script>

<style>
.dfu {
  background: linear-gradient(180deg, rgba(22,29,43,.8), rgba(16,21,31,.9));
  border: 1px solid var(--wr-line-2);
  border-radius: 16px;
  padding: 22px;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}
.dfu-head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px; }
.dfu-head-left { display: flex; align-items: flex-start; gap: 10px; }
.dfu-ico { width: 32px; height: 32px; border-radius: 9px; background: rgba(139,92,246,.12); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.dfu-title { font-size: 14.5px; font-weight: 800; color: var(--wr-text); }
.dfu-sub { font-size: 12px; color: var(--wr-mute); margin-top: 2px; }
.dfu-steps { display: flex; flex-direction: column; gap: 6px; margin-bottom: 20px; }
.dfu-step { display: flex; flex-direction: column; gap: 5px; }
.dfu-step-top { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
.dfu-step-label { display: flex; align-items: center; gap: 8px; min-width: 0; }
.dfu-num { width: 22px; height: 22px; border-radius: 6px; background: rgba(255,255,255,.06); display: flex; align-items: center; justify-content: center; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; color: var(--wr-mute); flex-shrink: 0; }
.dfu-step-name { font-size: 13px; font-weight: 500; color: var(--wr-text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.dfu-step-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.dfu-step-val { font-family: 'JetBrains Mono', monospace; font-size: 14px; font-weight: 700; color: var(--wr-text); font-variant-numeric: tabular-nums; }
.dfu-step-pct { font-family: 'JetBrains Mono', monospace; font-size: 13px; font-weight: 700; font-variant-numeric: tabular-nums; }
.dfu-track { height: 14px; border-radius: 7px; background: rgba(255,255,255,.04); overflow: hidden; position: relative; }
.dfu-fill { height: 100%; border-radius: 7px; position: relative; overflow: hidden; transition: width .6s ease; }
.dfu-shimmer {
  position: absolute;
  top: 0; bottom: 0;
  width: 40%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.25), transparent);
  animation: wr-shimmer 3s linear infinite;
}
.dfu-drop { font-size: 11.5px; color: #FF5A6B; font-weight: 500; padding-left: 30px; }
.dfu-rev {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: rgba(40,199,111,.06);
  border: 1px solid rgba(40,199,111,.2);
  border-radius: 12px;
}
.dfu-rev-left { display: flex; align-items: center; gap: 10px; }
.dfu-rev-ico { width: 32px; height: 32px; border-radius: 9px; background: rgba(40,199,111,.12); display: flex; align-items: center; justify-content: center; }
.dfu-rev-lbl { font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: rgba(40,199,111,.7); }
.dfu-rev-val { font-family: 'JetBrains Mono', monospace; font-size: 20px; font-weight: 900; color: #28C76F; font-variant-numeric: tabular-nums; letter-spacing: -.5px; }
.dfu-cpa { text-align: right; }
.dfu-cpa-lbl { font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: var(--wr-dim); }
.dfu-cpa-val { font-family: 'JetBrains Mono', monospace; font-size: 14px; font-weight: 700; color: var(--wr-text); font-variant-numeric: tabular-nums; }
</style>
